import Candidate from '../Candidate';
import Engagement from '../Engagement';
import {
  getCandidateModel
} from '../models/candidate';
import {
  COLLECTION__CANDIDATES,
  updateLoopbackRecord
} from '../services/BE/loopback.api';
import patchCandidateUpdateModel from './patchModelForCandidateUpdate.fun';

export default async function updateCandidate({
  id,
  update = {},
  key = 'updateCandidate',
  ...options
}) {
  Candidate.cleanCache();
  Engagement.cleanCache();
  update = patchCandidateUpdateModel(update);
  return updateLoopbackRecord({
    ...options,
    collection: COLLECTION__CANDIDATES,
    id,
    record: update,
    model: getCandidateModel(),
    key,
  });
}
